module.exports = __webpack_public_path__ + "img/gb835.prt.baff9fef.jpg";